const {
  enumerateWildcardPath
} = require('@truqc/content-path');
const {
  filterObject
} = require('./filterObject');
const array = [{
  identifier: 'station1',
  title: 'Station 1'
}, {
  identifier: 'station2',
  title: 'Station 2'
}, {
  identifier: 'station3',
  title: 'Station 3'
}, {
  identifier: 'station4',
  title: 'Station 4'
}, {
  identifier: 'station5',
  title: 'Station 5'
}, {
  identifier: 'station6',
  title: 'Station 6'
}, {
  identifier: 'cab',
  title: 'Cab'
}, {
  identifier: 'boom',
  title: 'Boom'
}, {
  identifier: 'axles',
  title: 'Axles'
}, {
  identifier: 'boomSupport',
  title: 'Boom Support'
}, {
  identifier: 'engine',
  title: 'Engine'
}, {
  identifier: 'fenders',
  title: 'Fenders'
}, {
  identifier: 'topHandler',
  title: 'Top Handler'
}, {
  identifier: 'smallSubs',
  title: 'Small Subs'
}, {
  identifier: 'paint',
  title: 'Paint'
}, {
  identifier: 'testAndAdjust',
  title: 'Test & Adjust'
}];
const getAssignmentGroups = () => array.reduce((acc, item, index) => {
  acc[item.identifier] = {
    title: item.title,
    _created: index + 1
  };
  return acc;
}, {});
const processAssignments = (checklists, processor) => {
  const questionPaths = '*/questionGroups/*/questions/*';
  const deficiencies = filterObject(checklists, questionPaths, 'option', 'fail');
  const photoPaths = '*/questionGroups/*/questions/*/supplementalData/photosCollection/*';
  enumerateWildcardPath(deficiencies, photoPaths, (photoPath, photoValue) => {
    if (photoValue !== undefined) {
      const {
        status: {
          open,
          complete
        } = {},
        assignedTo = {}
      } = photoValue;
      const [identifier] = Object.keys(assignedTo);
      const plusOpen = open !== undefined ? 1 : 0;
      const plusComplete = complete !== undefined ? 1 : 0;
      processor(identifier, plusOpen, plusComplete);
    }
  });
};
module.exports = {
  getAssignmentGroups,
  processAssignments
};